export const typesAddressdet = {
    GET_ADDRESSDET_SUCCESS:'GET_ADDRESSDET_SUCCESS',
    GET_ADDRESSDET_ERROR:'GET_ADDRESSDET_ERROR',
    GET_ADDRESSDET_BEGIN:'GET_ADDRESSDET_BEGIN',
    GET_SAVEADDRESS_SUCCESS:'GET_SAVEADDRESS_SUCCESS',
    GET_SAVEADDRESS_ERROR:'GET_SAVEADDRESS_ERROR',
    RESET_SAVEADDRESS_INIT : 'RESET_SAVEADDRESS_INIT',
    GET_SAVEADDRESS_BEGIN:'GET_SAVEADDRESS_BEGIN'


}
